module.exports = __webpack_public_path__ + "img/compansatory.d4135213.png";